document.addEventListener('DOMContentLoaded', function () {
  const closeButton = document.getElementById('close-announcement-bar');
  const announcementBar = document.querySelector('.top-announcement-bar');
  const body = document.body;

  if (closeButton && announcementBar) {
    // Check if the cookie exists
    const isClosed = document.cookie.split(';').some((item) => item.trim().startsWith('announcementBarClosed='));

    if (isClosed) {
      // If cookie exists, keep announcement bar hidden
      announcementBar.style.display = 'none';
      body.classList.remove('announcement-bar-showing');
    } else {
      // If no cookie exists, show the announcement bar
      announcementBar.style.display = 'block';
      body.classList.add('announcement-bar-showing');
    }

    closeButton.addEventListener('click', function () {
      // Hide the announcement bar
      announcementBar.style.display = 'none';
      body.classList.remove('announcement-bar-showing');

      // Set a cookie to hide the bar for 24 hours
      document.cookie = 'announcementBarClosed=true; max-age=86400; path=/';
    });
  }

  const countdownElement = document.querySelector('.announcement_bar__countdown');

  if (countdownElement) {
    const targetDate = countdownElement.getAttribute('data-countdown');
    const serverNow = countdownElement.getAttribute('data-now');
    if (targetDate && serverNow) {
      // Parse both dates (format: YYYY-MM-DD HH:MM) and treat as PST
      const targetDateTime = new Date(targetDate.replace(' ', 'T') + ':00-08:00'); // PST is UTC-8
      const serverDateTime = new Date(serverNow.replace(' ', 'T') + ':00-08:00'); // PST is UTC-8

      // Calculate the difference between server time and target time when page loaded
      const initialDifference = targetDateTime.getTime() - serverDateTime.getTime();

      // Get the client's page load time
      const pageLoadTime = new Date();

      function updateCountdown() {
        // Calculate how much time has passed since page load
        const currentTime = new Date();
        const timeSincePageLoad = currentTime.getTime() - pageLoadTime.getTime();

        // Calculate current countdown by subtracting elapsed time from initial difference
        const currentDifference = initialDifference - timeSincePageLoad;

        if (currentDifference > 0) {
          const days = Math.floor(currentDifference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((currentDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((currentDifference % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((currentDifference % (1000 * 60)) / 1000);

          const daysElement = document.getElementById('days');
          const hoursElement = document.getElementById('hours');
          const minutesElement = document.getElementById('minutes');
          const secondsElement = document.getElementById('seconds');

          // Update values
          daysElement.textContent = days;
          hoursElement.textContent = hours;
          minutesElement.textContent = minutes;
          secondsElement.textContent = seconds;

          // Hide/show elements based on their values
          const daysItem = daysElement.closest('.announcement_bar__countdown__item');
          const hoursItem = hoursElement.closest('.announcement_bar__countdown__item');

          if (daysItem) {
            daysItem.style.display = days === 0 ? 'none' : 'flex';
          }
          if (hoursItem) {
            hoursItem.style.display = hours === 0 && days === 0 ? 'none' : 'flex';
          }

          // Show countdown after first update
          if (!countdownElement.classList.contains('countdown-ready')) {
            countdownElement.classList.add('countdown-ready');
          }
        } else {
          // Countdown has ended
          // document.getElementById('days').textContent = '0';
          // document.getElementById('hours').textContent = '0';
          // document.getElementById('minutes').textContent = '0';
          // document.getElementById('seconds').textContent = '0';
          countdownElement.style.display = 'none';
        }
      }

      // Update countdown immediately
      updateCountdown();

      // Update countdown every second
      setInterval(updateCountdown, 1000);
    }
  }
});
